import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_LEAD_CAPTURE = 'GET_LEAD_CAPTURE';
export const GET_LEAD_CAPTURE_SUCCESS = 'GET_LEAD_CAPTURE_SUCCESS';
export const GET_LEAD_CAPTURE_FAILURE = 'GET_LEAD_CAPTURE_FAILURE';

// Action Creators
export const getLeadCapture = () => ({
  type: GET_LEAD_CAPTURE,
});

export const getLeadCaptureSuccess = (data) => ({
  type: GET_LEAD_CAPTURE_SUCCESS,
  payload: data,
});

export const getLeadCaptureFailure = (error) => ({
  type: GET_LEAD_CAPTURE_FAILURE,
  payload: error,
});

// Thunk Function
export const getLeadCaptureCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(getLeadCapture());
    try {
      const response = await getMethodWithToken(url.leadCapture + data);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getLeadCaptureSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(getLeadCaptureFailure(response?.data));
      }
    } catch (error) {
      dispatch(getLeadCaptureFailure(error?.message));
    }
  };
};
